import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Store } from '@ngrx/store';
import { raceAdminActions } from 'src/app/core/store/admin/race-admin/raceAdmin.action';

@Component({
  selector: 'aoe-init-race-dialog',
  imports: [MatDialogModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  templateUrl: './init-race-dialog.component.html',
  styleUrl: './init-race-dialog.component.scss',
})
export class InitRaceDialogComponent implements OnInit {

  raceFG!: FormGroup;

  constructor(
    private readonly store: Store,
    private readonly fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { eventId: string },
  ) { }

  ngOnInit(): void {
    this.raceFG = this.fb.group({
      name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(150)]),
      slug: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(150)]),
    })
  }

  submit() {
    if (this.raceFG.valid)
      this.store.dispatch(raceAdminActions.createRace({ payload: { ...this.raceFG.value, eventId: this.data.eventId }, eventId: this.data.eventId }));
  }

}
